// utils/formatDate.ts
import moment from 'moment';

export const formatDate = (date: string | undefined, fallback = '-'): string =>
  date && moment(date).isValid() ? moment(date).format('DD/MM/YYYY') : fallback;
// utils/displayValue.ts
export const displayValue = (value: string | undefined | null): string => {
  if (value == null) return '-';
  const str = String(value).trim();
  return str === '' ? '-' : str;
};
